/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Link } from '@bd/bdcore-named-routes';
import { SmoothLink } from '@bd/bdcore-utilities';
import { css, cx } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../styles';

const styles = css`
width: 100%;
background-size: auto;
background-position: top;
background-color: ${colors.color1};
color: #999;
font:700 18px/1 ${typography.SansSerif};
text-align: center;
position:relative;
z-index: 6;
border-bottom:1px solid #333;

.PageMenu_title {
width: auto;
background-image: url(/images/icon-triangle-white.svg);
background-repeat: no-repeat;
background-position: 92% center;
display: inline-block;
padding:15px 30px 15px 15px;
color: white;
font-weight: 800;
text-decoration: none;
@media (min-width: 992px) {
  display: none;
}
}
.PageMenu_list {
padding: 0;
text-align: left;
width: 300px;
display: none;
position: absolute;
left: 50%;
margin-left: -150px;
top: 54px;
list-style: none;
box-shadow: 0 2px 4px 0 rgba(0,0,0,0.25);
&.open {
  display: block;
}
@media (min-width: 992px) {
  list-style: none;
  margin: 0;
  display: block;
  position: relative;
  width: auto;
  left: auto;
  margin-left: 0;
  top: auto;
  box-shadow: none;
  text-align: center;
}
}
.PageMenu_listItem {
@media (min-width: 992px) {
  display: inline-block;
}
a {
  background-color: #FFFFFF;
  padding: 15px;
  border-bottom: 1px solid #EEEEEE;
  display: block;
  color: #333;
  transition: all .25s ease;
  text-decoration: none;
  text-transform: capitalize;
  &.active {
    color: ${colors.color2};
  }
  @media (min-width: 992px) {
      background-color: transparent;
      text-align: center;
      font-weight:700;
      color: ${colors.white};
      padding: 25px 15px;
      border: 0;
      &.active {
        color: white;
        background:${colors.color4};
      }
    }
}
a:hover, a:active, a:focus {
  color: ${colors.color2};
  @media (min-width: 992px) {
      color: white;
      background:${colors.color4};
    }
}
}
`;

class PageMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdown: false,
    };

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.addWrapperRef = this.addWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mouseup', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleClickOutside);
  }

  toggleDropdown(e) {
    e.preventDefault();

    this.setState({
      dropdown: !this.state.dropdown,
    });
  }

  closeDropdown() {
    const { onSelect } = this.props;

    if (onSelect) {
      onSelect();
    }

    this.setState({
      dropdown: false,
    });
  }

  addWrapperRef(node) {
    if (!this.wrapperRefs) {
      this.wrapperRefs = [];
    }
    this.wrapperRefs.push(node);
  }

  handleClickOutside(event) {
    if (this.wrapperRefs && !this.wrapperRefs.find(ref => ref && ref.contains(event.target))) {
      this.closeDropdown();
    }
  }

  render() {
    const { className, title, items, match } = this.props;
    const { dropdown } = this.state;

    return (
      <div className={cx(styles, className)}>
        <div className="container">
          <a href="" className="PageMenu_title" ref={this.addWrapperRef} onClick={this.toggleDropdown}>{title}</a>
          <ul className={`PageMenu_list ${dropdown ? 'open' : ''}`} ref={this.addWrapperRef}>
            {
              items.map(item => {
                if (item.hide) {
                  return null;
                }

                if (item.name) {
                  return (
                    <li className="PageMenu_listItem" key={item.title} onClick={this.closeDropdown}>
                      <Link
                        name={item.name}
                        keepParams={item.keepParams}
                        params={item.params}
                      >
                        {item.title}
                      </Link>
                    </li>
                  );
                } else if (item.id) {
                  return (
                    <li key={item.id} onClick={this.closeDropdown}>
                      <SmoothLink
                        href={item.id}
                      >
                        {item.title}
                      </SmoothLink>
                    </li>
                  );
                }

                return (
                  <li key={item.path} onClick={this.closeDropdown}>
                    <a
                      href={item.path}
                      className={`${(match.path === item.path) ? 'active' : ''}`}
                    >
                      {item.title}
                    </a>
                  </li>
                );
              })
            }
          </ul>
        </div>
      </div>
    );
  }
}

PageMenu.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      name: PropTypes.string,
      id: PropTypes.string,
      title: PropTypes.string,
      params: PropTypes.object,
      keepParams: PropTypes.bool,
    }),
  ),
  match: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
};

PageMenu.defaultProps = {
  className: undefined,
  items: [],
  onSelect: undefined,
};

export default withRouter(PageMenu);



// WEBPACK FOOTER //
// ./src/components/PageMenu.js